module.exports = "\r\n<router-outlet *ngIf=\"shouldDisplayPlanOrder()\"\r\n></router-outlet>\r\n\r\n\r\n\r\n"